import Types from './types';

export const addBefore = (item1, item2) => ({
    payload: { item1, item2 },
    type: Types.ADD_BEFORE_COLUMN,
});

export const changeColumnPosition = (item1, item2) => ({
    payload: { item1, item2 },
    type: Types.CHANGE_COLUMN_POSITION,
});


export const reset = () => ({
    type: Types.RESET,
});

export const resetAll = () => ({
    type: Types.RESET_ALL,
});

export const select = (value) => ({
    payload: value,
    type: Types.SELECT,
});

export const clearSelected = () => ({
    type: Types.CLEAR_SELECTED
});

export const setSearchQuery = (value) => ({
    payload: value,
    type: Types.SET_SEARCH_QUERY,
});

export const setFilter = (filter) => ({
    payload: filter,
    type: Types.SET_FILTER,
});

export const setEnd = () => ({
    type: Types.SET_END,
});

export const setNoResults = () => ({
    type: Types.SET_NO_RESULTS,
});

export const resetFilter = (all = false) => ({
    payload: all,
    type: Types.RESET_FILTER,
});

export const applyFilter = (page) => ({
    page,
    type: Types.APPLY_FILTER,
});
export const setTotalKeywords = (data) => ({
    payload: data,
    type: Types.SET_TOTAL_KEYWORDS,
});

export const deepSearch = (keyword) => ({
    meta: {
        keyword,
    },
    type: Types.DEEP_SEARCH,
});

export const fetch = (currentPage, query = '', page = 1) => ({
    meta: {
        currentPage,
        page,
        query,
    },
    type: Types.FETCH,
});

export const fetchProduct = (asin) => ({
    meta: {
        asin,
    },
    type: Types.FETCH_PRODUCT,
});

export const pushToHistory = (keyword) => ({
    meta: {
        keyword,
    },
    type: Types.PUSH_TO_HISTORY,
});

export const fetchHistory = () => ({
    type: Types.FETCH_HISTORY,
});

export const seeReport = (id) => ({
    meta: {
        id
    },
    type: Types.SEE_REPORT,
});

export const setHistory = (data) => ({
    payload: data,
    type: Types.SET_HISTORY,
});

export const updateHistory = (data) => ({
    payload: data,
    type: Types.UPDATE_HISTORY,
});

export const setProduct = (data) => ({
    payload: data,
    type: Types.SET_PRODUCT,
});

export const setData = (data) => ({
    payload: data,
    type: Types.SET_DATA,
});

export const updateData = (data) => ({
    payload: data,
    type: Types.UPDATE_DATA,
});

export const updatePagination = (data) => ({
    payload: data,
    type: Types.UPDATE_PAGINATION,
});

export const setLoading = (value) => ({
    payload: value,
    type: Types.SET_LOADING,
});

export const setError = (value) => ({
    payload: value,
    type: Types.SET_ERROR,
});


export const setStrictSearch = (value) => ({
    payload: value,
    type: Types.SET_STRICT_SEARCH,
});

export const setSort = (sorting) => ({
    payload: sorting,
    type: Types.SET_SORT,
});

export const addColumns = (columns) => ({
    payload: columns,
    type: Types.ADD_COLUMNS,
});

export const setColumns = (columns) => ({
    payload: columns,
    type: Types.SET_COLUMNS,
});

export const removeColumn = (column) => ({
    payload: column,
    type: Types.REMOVE_COLUMN,
});

export const addTracked = (id, keyword) => ({
    payload: {
        id, keyword
    },
    type: Types.ADD_TRACKED,
});

export const trackKeywords = (keywords, asin, productId) => ({
    meta: {
        asin,
        keywords,
        productId
    },
    type: Types.TRACK_KEYWORDS,
});

/* CATEGORIES */

export const fetchCategories = (str) => ({
    payload: str,
    type: Types.FETCH_CATEGORIES,
});

export const fetchCategoriesFail = () => ({
    type: Types.FETCH_CATEGORIES_FAIL
});

export const updateCategories = (categories) => ({
    payload: categories,
    type: Types.UPDATE_CATEGORIES,
});

export const setCategories = (categories) => ({
    payload: categories,
    type: Types.SET_CATEGORIES
});

export const pinCategory = (category) => ({
    payload: category,
    type: Types.PIN_CATEGORY,
});

export const removeCategory = (category) => ({
    payload: category,
    type: Types.REMOVE_CATEGORY,
});
